import { useTranslation } from 'react-i18next';
import { Card, CardBody } from 'reactstrap';

import { PoisonUsage } from 'api/visitReports/type';

const UsedPoisonsElement: React.FC<{ data: PoisonUsage }> = ({ data }) => {
  const { t } = useTranslation();

  return (
    <Card className="card shadow-hover">
      <CardBody>
        <div className="d-lg-flex align-items-center">
          {/* Column 1 */}
          <div className="col-lg-1 text-center">
            <div>
              <i className="ri-bubble-chart-fill text-danger fs-1" />
            </div>
          </div>

          {/* Column 2 */}
          <div className="col-lg-2">
            <div className="ms-4">
              <h5 className="fs-16 text-center mb-2">{data?.poison_name}</h5>
              <p className="text-muted text-center mb-0">{t('UsedPoisons.accordion.card.poison-name')}</p>
            </div>
          </div>

          {/* Column 3 */}
          <div className="col-lg-2">
            <div className="ms-4">
              <h5 className="fs-16 text-center mb-2">
                {data?.poison_amount} {data?.amount_type}
              </h5>
              <p className="text-muted text-center mb-0">{t('UsedPoisons.accordion.card.amount')}</p>
            </div>
          </div>

          {/* Column 4 */}
          <div className="col-lg-2">
            <div className="ms-4">
              <h5 className="fs-16 text-center mb-2">{data?.usage_method}</h5>
              <p className="text-muted text-center mb-0">{t('UsedPoisons.accordion.card.usage-method')}</p>
            </div>
          </div>

          {/* Column 5 */}
          <div className="col-lg-2">
            <div className="ms-4">
              <h5 className="fs-16 text-center mb-2">{data?.usage_reason}</h5>
              <p className="text-muted text-center mb-0">{t('UsedPoisons.accordion.card.usage-reason')}</p>
            </div>
          </div>

          {/* Column 6 */}
          <div className="col-lg-2">
            <div className="ms-4">
              <h5 className="fs-16 text-center mb-2">{data?.usage_place}</h5>
              <p className="text-muted text-center mb-0">{t('UsedPoisons.accordion.card.usage-place')}</p>
            </div>
          </div>

          {/* Column 7 */}
          <div className="col-lg-1 text-center">
            <div>
              <i title={data?.added_by} className="ri-user-voice-fill text-info fs-1" />
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default UsedPoisonsElement;
